let locales = {
    //companiesChangePassword_: '',
    companiesChangePassword_title: 'Cambiare la password',
    companiesChangePassword_newPassword: 'Nuova password',
    companiesChangePassword_repeatPassword: 'Ripetere la password',
    companiesChangePassword_message: 'Le password non corrispondono',
};

export default locales;